import 'bootstrap/dist/css/bootstrap.min.css'
import './style.scss'

const WhySection = () => {
  return (
    <section className='whySection' id='why-subter'>
      <h1 className='title'>Why Subter?</h1>

      <div className='content'>
        <div className='left'>
          <p>
            Social Networking, with its alluring offering of connecting you with
            your friends and family, mines and harvests every piece of
            information you share on their platform. Every interaction, every
            like, every view and click you make, the content and sentiment of
            the posts you share; all are analyzed, scrutinized, and cataloged
            for future use by the platforms. This sort of broad and deep
            tracking, combined with the information that is willingly posted
            into social networking platforms, allows Big Tech to use your
            identity and your information like digital oil. You, and your
            information, are not a digital commodity to be sold.
          </p>
          <br />
          <p>
            In addition to this invasion of privacy, it's been shown time and
            time again that corporations, large and small, do not do enough to
            protect their users' data. The list of data breaches we've all been
            subjected to is innumerable. And there's no repercussions to these
            breeches to prompt businesses to handle our data with care.{' '}
          </p>
        </div>
        <div className='right'>
          <iframe
            width='100%'
            height='283'
            src='https://www.youtube.com/embed/ztop4hRW1NM'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
            title='Embedded youtube'
          />
          <p>
            A solution is needed so that we can still participate online and
            preserve our privacy and security. A solution that doesn't force us
            to run off to some other no-mans-land to be safe.{' '}
            <strong>
              Subter fills this very critical need for secure means of public
              communication.
            </strong>
          </p>
        </div>
      </div>
    </section>
  )
}

export default WhySection
